import React from 'react';
import FuzzySearchDecorator from '../../../decorators/FuzzySearchDecorator';
import ValueList from '../../../components/ValueList';
import { UserAvatar, AvatarSizes } from 'components/avatar';
import MenuItem from 'material-ui/MenuItem';
import { withStyles } from '../../../styles';
import styles from './styles';

const CompanySearchRow = ({ text, styles, info2, info3 }) => {
    return (
        <div style={styles.row}>
            <div style={styles.info1}>{text}</div>
            <div style={styles.info2}>{info2}</div>
            <div style={styles.info3}>{info3}</div>
        </div>
    );
};

const ResponsableSearchRow = ({ id, text, styles }) => {
    return (
        <div>
            <UserAvatar id={id} size={AvatarSizes.NORMAL} style={styles.avatarRow} />
            <span style={styles.valueListTextMenu}>{text}</span>
        </div>
    );
};

const ContactSearchRow = ({ text, styles, info2, info3 }) => {
    return (
        <div style={styles.row}>
            <div style={styles.info1}>{text}</div>
            <div style={styles.info2}>{info2}</div>
            <div style={styles.info3}>{info3}</div>
        </div>
    );
};

const OtherSearchRow = ({ text, styles }) => {
    return <span style={styles.valueListTextMenu}>{text}</span>;
};

const processData = (entity, styles, data) => {
    return data.toArray().map((valueList) => {
        let text = valueList.MatchingInfo;
        let id = valueList.Id;
        let extraInfo =
            valueList.ExtraInfo && valueList.ExtraInfo !== '' ? valueList.ExtraInfo : '-';
        let extraInfo2 =
            valueList.ExtraInfo2 && valueList.ExtraInfo2 !== '' ? valueList.ExtraInfo2 : '-';
        let extraInfo3 =
            valueList.ExtraInfo3 && valueList.ExtraInfo3 !== '' ? valueList.ExtraInfo3 : '-';
        let result = null;

        switch (entity) {
            case 'companies':
            case 'empresas':
            case 'expedientes':
            case 'productos':
                result = (
                    <CompanySearchRow
                        key={id}
                        text={text}
                        styles={styles}
                        info2={extraInfo}
                        info3={extraInfo3}
                    />
                );
                break;
            case 'companyrates':
                result = (
                    <CompanySearchRow
                        key={id}
                        text={text}
                        styles={styles}
                        info2={extraInfo2}
                        info3={extraInfo}
                    />
                );
                break;
            case 'users':
                result = <ResponsableSearchRow key={id} text={text} id={id} styles={styles} />;
                break;
            case 'contacts':
            case 'viewcontactosfullname':
            case 'viewusuariosfullname':
                result = (
                    <ContactSearchRow
                        key={id}
                        text={text}
                        styles={styles}
                        info2={extraInfo}
                        info3={extraInfo3}
                    />
                );
                break;
            default:
                result = <OtherSearchRow key={id} text={text} styles={styles} />;
                break;
        }

        return {
            text: text,
            value: <MenuItem key={id}>{result}</MenuItem>,
        };
    });
};

const FuzzySearchAutoCompleteFM = (props) => {
    const { entity, styles } = props;
    const AutoCompleteWrapper = FuzzySearchDecorator(entity, entity)(ValueList);
    return <AutoCompleteWrapper {...props} processData={processData.bind(null, entity, styles)} />;
};

export default withStyles(styles)(FuzzySearchAutoCompleteFM);
